import React from 'react';

import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useFormikContext } from 'formik';

export const SubmittingOverlay: React.FC = React.forwardRef((_props, ref) => {
  const { isSubmitting } = useFormikContext() ?? {};

  return (
    <Backdrop
      open={isSubmitting}
      style={{
        zIndex: 999999,
      }}
      ref={ref}
    >
      <CircularProgress color="primary" />
    </Backdrop>
  );
});
